import React, { useEffect, useState } from "react";
import { callNonStoreApi, isNullOrUndefined } from "../utils/utils";
import { GetGrowezyClientOnboardingMetrics } from "../utils/ApiEndpoints";
import { Table, Tag } from "antd";
import { primaryActionColor } from "../utils/constants";
import { Checkbox } from "@mui/material";
import { AddFlex, CustomText } from "../Components/reusableStyles";
import { createStyles } from "antd-style";
const columns = [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Username",
    dataIndex: "username",
    key: "username",
  },
  {
    title: "Domain",
    dataIndex: "domain",
    key: "domain",
    render: (text) => {
      return (
        <Tag
          color={
            isNullOrUndefined(text) ||
            text === "login.growezy.club" ||
            text === "localhost"
              ? primaryActionColor
              : "orange"
          }
        >
          {isNullOrUndefined(text) ||
          text === "login.growezy.club" ||
          text === "localhost"
            ? "Growezy"
            : "Bodhi"}
        </Tag>
      );
    },
  },
  {
    title: "Cover Image",
    dataIndex: "coverImageStatus",
    key: "coverImageStatus",
    render: (text) => {
      return <>{text === "-" ? "Not Updated" : "Updated"}</>;
    },
  },
  {
    title: "Bio Status",
    dataIndex: "bioStatus",
    key: "bioStatus",
    render: (text) => {
      return <>{text > 0 ? "Updated" : "Not Updated"}</>;
    },
  },
  {
    title: "About Status",
    dataIndex: "aboutStatus",
    key: "aboutStatus",
    render: (text) => {
      return <>{text > 0 ? "Updated" : "Not Updated"}</>;
    },
  },
  {
    title: "Protfolio",
    dataIndex: "portfolio",
    key: "portfolio",
  },
  {
    title: "Testimonials",
    dataIndex: "testimonials",
    key: "testimonials",
  },
  {
    title: "Integrations",
    dataIndex: "integrations",
    key: "integrations",
  },
];

const useStyle = createStyles(({ css, token }) => {
  const { antCls } = token;
  return {
    customTable: css`
      ${antCls}-table {
        ${antCls}-table-container {
          ${antCls}-table-body,
          ${antCls}-table-content {
            scrollbar-width: thin;
            scrollbar-color: #eaeaea transparent;
            scrollbar-gutter: stable;
          }
        }
      }
    `,
  };
});

function OnboardingMetrics() {
  const { styles } = useStyle();
  const [loading, setLoading] = useState(true);
  const [isShowingOnlyBodhiClients, setIsShowingOnlyBodhiClients] =
    useState(false);

  const [initialClients, setInitialClients] = useState([]);
  const [clients, setClients] = useState([]);
  const [showOnlyBodhiClients, setShowOnlyBodhiClients] = useState();

  const handleShowOnlyBodhiClients = (_flag) => {
    let _clients;
    if (_flag) {
      _clients = initialClients.filter(
        (data) => data.domain === "coachlogin.bodhischoolofyoga.com"
      );
    } else {
      _clients = initialClients;
    }
    setClients(_clients);
  };

  const handleGetClientList = async (force) => {
    setLoading(true);
    const res = await callNonStoreApi(GetGrowezyClientOnboardingMetrics);
    setClients(res.data.data);
    setInitialClients(res.data.data);
    setLoading(false);
  };
  useEffect(() => {
    handleGetClientList();
  }, []);

  return (
    !loading && (
      <div style={{ padding: "30px" }}>
        <AddFlex gap="5px" alignItems="center">
          <Checkbox
            checked={isShowingOnlyBodhiClients}
            onChange={(e) => {
              setIsShowingOnlyBodhiClients((prev) => !prev);
              handleShowOnlyBodhiClients(e.target.checked);
            }}
            sx={{ padding: 0 }}
          />
          <CustomText color="black">Show only bodhi clients</CustomText>
        </AddFlex>
        <Table
          className={styles.customTable}
          dataSource={clients}
          columns={columns}

          //   scroll={{
          //     y: 100 * 5,
          //   }}
        />
      </div>
    )
  );
}

export default OnboardingMetrics;
